<template>
  <main class="smaller-padding comments">
    <comments-list />
  </main>
</template>

<script>
    import CommentsList from '@components/modules/comments/CommentsList.vue'

    export default {
        components: {
            CommentsList
        },

        data() {
            return {

            }
        },

        destroyed() {
        },

    }
</script>

<style lang="scss" scoped>
.comments {
  .comments-list {
    padding-bottom: 100px;
    padding-right: 50px;
  }
}
</style>
